import React from "react";
import NavBar from "./components/NavBar";
import About from "./components/About";
import StacksAndProjects from "./components/StacksAndProjects";
import Links from "./components/Links";
import { Divider } from "antd";

const App = () => {
  return (
    <div className="portfolio my-5">
      <NavBar />
      <div className="container col-md-6 offset-md-3">
        <About />
        <Links />
        <StacksAndProjects />
        <Divider className="bg-light" />
        <Links />
        <br />
        <br />
        <br />
      </div>
    </div>
  );
};

export default App;
